import { useRouterState } from '@tanstack/react-router';

export const useCompanyQuerystringParams = () => {
  // Use router's reactive state to get search string, which updates on navigation
  const searchString = useRouterState({
    select: (state) => {
      return state.location.searchStr;
    },
  });

  const companyId = new URLSearchParams(searchString).get('companyId') || '';

  return {
    companyId,
  };
};
